/*
  One behaviour for every sign-up on the site.

  Shopify's own {% form 'customer' %} posts the whole page: the browser leaves,
  comes back on a fresh load and lands wherever that load lands — on the
  homepage, the top, with the confirmation forty thousand pixels below in the
  footer. So the form is sent in the background instead, and the confirmation
  takes the form's place, where the person is already looking.

  Two halves of a contract:

  - The form carries data-signup and holds three parts: [data-signup-fields],
    which is what gets swapped out; [data-signup-success], hidden until it is
    earned; and [data-signup-error], empty until something is wrong.
  - The Liquid keeps its own {% if form.posted_successfully? %} branch. That is
    what answers when this script cannot: a visitor with no JavaScript, and the
    moment Shopify stops to ask whether someone is a robot.

  Nothing here writes copy. Every word it shows is already in the page, put
  there in Liquid, so the theme editor stays in charge of the wording.
*/
(function () {
  /*
    Shopify answers a sign-up with a redirect back to the page it came from.
    Which redirect it is, is the whole answer: the address carries this when the
    contact was taken, and carries it never when the form came back with
    something to fix.
  */
  var ACCEPTED = 'customer_posted=true';

  function parts(form) {
    return {
      fields: form.querySelector('[data-signup-fields]'),
      success: form.querySelector('[data-signup-success]'),
      error: form.querySelector('[data-signup-error]'),
      button: form.querySelector('[type="submit"]')
    };
  }

  function sending(form, on) {
    var button = parts(form).button;
    if (!button) return;

    if (on) {
      var label = button.getAttribute('data-signup-sending');
      if (label) {
        button.setAttribute('data-signup-label', button.innerHTML);
        button.innerHTML = label;
      }
      button.disabled = true;
      return;
    }

    var was = button.getAttribute('data-signup-label');
    if (was !== null) {
      button.innerHTML = was;
      button.removeAttribute('data-signup-label');
    }
    button.disabled = false;
  }

  function fail(form, message) {
    var p = parts(form);
    sending(form, false);
    if (!p.error) return;

    /* The form writes its own sentence for the times we only know that it did
       not work — a connection that dropped, an answer we cannot read. */
    p.error.textContent = message || p.error.getAttribute('data-signup-error-text') || '';
    p.error.hidden = false;
  }

  function succeed(form) {
    var p = parts(form);

    if (p.error) {
      p.error.hidden = true;
      p.error.textContent = '';
    }
    /* Hidden rather than removed: the fields keep whatever was typed, in case
       anything ever needs to hand them back. */
    if (p.fields) p.fields.hidden = true;
    if (p.success) p.success.hidden = false;

    /* The drawers listen for this to stop themselves from closing on the
       confirmation before it has been read. */
    form.dispatchEvent(new CustomEvent('hogo:signup', { bubbles: true }));
  }

  /*
    Shopify does not answer in JSON, it answers with the page. So the page it
    sends back is read the same way a person would read it: find this form in
    it, and see whether it came back carrying an error.
  */
  function readAnswer(form, url, html) {
    var answer;

    try {
      answer = new DOMParser().parseFromString(html, 'text/html');
    } catch (e) {
      answer = null;
    }

    if (answer) {
      var again = form.id ? answer.getElementById(form.id) : null;
      var problem = (again || answer).querySelector('[data-signup-server-error]');
      var said = problem ? problem.textContent.trim() : '';
      if (said) return { ok: false, message: said };
    }

    if (url && url.indexOf(ACCEPTED) > -1) return { ok: true };
    return { ok: false, message: '' };
  }

  function send(form) {
    var body = new FormData(form);

    sending(form, true);

    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: body,
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        /*
          Shopify stops some sign-ups to ask whether the visitor is a robot, and
          that question cannot be answered from in here. The form is handed back
          to the browser to post the old way, which is the one thing that gets
          the visitor to the page where they can answer it.
        */
        if (response.url && response.url.indexOf('/challenge') > -1) {
          form.submit();
          return null;
        }

        return response.text().then(function (html) {
          return readAnswer(form, response.url, html);
        });
      })
      .then(function (answer) {
        if (!answer) return;
        if (answer.ok) succeed(form);
        else fail(form, answer.message);
      })
      .catch(function () {
        fail(form, '');
      });
  }

  function watch(form) {
    if (form.hogoSignup) return;
    form.hogoSignup = true;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (parts(form).button && parts(form).button.disabled) return;
      send(form);
    });
  }

  function collect() {
    var forms = document.querySelectorAll('form[data-signup]');
    for (var i = 0; i < forms.length; i++) watch(forms[i]);
  }

  collect();
  document.addEventListener('DOMContentLoaded', collect);
  /* The theme editor rebuilds a section by replacing its markup outright, so
     the form that comes back is a different element and needs watching afresh. */
  document.addEventListener('shopify:section:load', collect);
})();
